<template>
    <a v-if="is_external" :href="url" :target="link_target" :title="link_title">
      <slot></slot>
    </a>
    <router-link v-else :to="url" :target="link_target" :title="link_title">
      <slot></slot>
    </router-link>
</template>

<script>
export default {
    name: 'link-item',

    props: {
      link: Object,
      post_link: {
        type: String,
        default: '',
      },
      new_window: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        is_external: false,
        url: '',
        link_target: '',
        link_title: '',
      }
    },

    methods: {
      isFile (url) {
        url = new URL(url, location.origin);
        return url.pathname.split('/').pop().indexOf('.') > 0;
      },
      isExternal (url) {
        return new URL(url, location.origin).origin.indexOf(window.globals.home_url) === -1;
      },
    },

    mounted() {
      if (this.link) {
        this.url = this.link.url;
        this.link_target = this.link.target;
        this.link_title = this.link.title;
      } else {
        this.url = this.post_link.includes(window.globals.home_url) ? this.post_link.replace(window.globals.home_url, "") : this.post_link;
      }


      if (this.url.indexOf(window.globals.home_url) !== -1) {
        this.url = this.url.replace(window.globals.home_url, '');
      }


      if (this.new_window || this.isExternal(this.url) || this.isFile(this.url) || this.link_target === '_black') {
        if(this.url.indexOf('shop.charleston.org.uk') === -1) {
          this.link_target = '_blank';
        }
        this.is_external = true;
      }
    },
}

</script>
